import BaseHeader from './base-header';

export default BaseHeader;